module.exports = __webpack_public_path__ + "static/media/vantr-logo-blue-font.07a8417c.webp";